var render = function () {
  var _obj
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "a-modal",
    {
      staticClass: "v2",
      class:
        ((_obj = {}),
        (_obj[_vm.className] = true),
        (_obj.xlarge = _vm.xlarge),
        (_obj.large = _vm.large),
        _obj),
      attrs: { visible: true, footer: null },
      on: { cancel: _vm.handleCancel },
    },
    [
      _c("div", { staticClass: "custom-modal-content" }, [
        _vm.showTitle
          ? _c(
              "div",
              { staticClass: "custom-modal-header" },
              [
                _vm._t("title", function () {
                  return [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.title) +
                        "\n            "
                    ),
                  ]
                }),
                _vm._v(" "),
                _c("div", { staticClass: "subtitle" }, [
                  _vm._v(_vm._s(_vm.description)),
                ]),
              ],
              2
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", { staticClass: "custom-modal-body" }, [_vm._t("default")], 2),
        _vm._v(" "),
        _vm.showFooter
          ? _c("div", { staticClass: "custom-modal-footer" }, [
              _c(
                "div",
                { staticClass: "actions" },
                [
                  _c(
                    "a-button",
                    {
                      on: {
                        click: function ($event) {
                          $event.stopPropagation()
                          return _vm.handleCancel.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v(" " + _vm._s(_vm.cancelText))]
                  ),
                  _vm._v(" "),
                  _c(
                    "a-button",
                    {
                      staticClass: "pr-confirm-btn",
                      attrs: { type: "primary" },
                      on: { click: _vm.handleConfirm },
                    },
                    [
                      _vm._v(
                        "\n                    " +
                          _vm._s(_vm.okText) +
                          "\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ])
          : _vm._e(),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }